import { Validator } from '@vista-digital/validator';
export const memberFormPrimarySiteFieldConfigValidator = Validator.object({
    enableSearch: Validator.boolean()
});
export const defaultMemberFormPrimarySiteFieldConfig = {
    enableSearch: true
};
